import { AdvertisingSlot } from 'react-advertising'
import styled from 'styled-components'

import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const StyledGptSponsoredLeft = styled(AdvertisingSlot)``
export const StyledGptSponsoredRight = styled(AdvertisingSlot)``

export const StyledGptImageGalleryOverlay = styled(AdvertisingSlot)(
  ({ theme }) => `
  overflow: hidden;
  min-height: 90px;
  width: 320px;
  margin: 0 auto;

  ${MEDIA_QUERIES(theme).large} {
    width: 728px;
  }
`
)

export const GptImageGalleryOverlayWrapper = styled.div`
  overflow: hidden;
  position: absolute;
  min-height: 90px;
  top: 0;
  width: 100%;
`

export const GptLeaderWrapper = styled.div(
  ({ theme }) => `
  display: none;
  margin: ${theme.spacing.default} 0;

  ${MEDIA_QUERIES(theme).medium} {
    display: block;
    min-height: 90px; 
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
)

export const StyledGptFooter = styled(AdvertisingSlot)`
  display: flex;
  justify-content: center;
  align-items: center;
`
